// # Regisration

define('modules/Registration/Registration',[
    'jquery',
    'global/all',
    './Registration.Forms'
], function ($, Roc , RegistrationForms) {
    'use strict';

    var registrationData;
    var redirectUrl;
    var forms = RegistrationForms;

    var btns = {
        register: '#registrationBtn'
    };


    function btnRegisterEvt() {
        $(document).on('click', btns.register, function () {
            register();
        });
    }

    function bindEvents() {
        if (bindEvents.COMPLETED) {
            return;
        }

        //Roc.Config.loadConfig().then(function () {
            btnRegisterEvt();
            bindEvents.COMPLETED = true;
        //});
    }

    function initRegistration() {
        registrationData = {
            '$email': $(Roc.Validation.getField(forms.CustomRegistration, 'Email').Field),
            '$email2': $(Roc.Validation.getField(forms.CustomRegistration, 'Confirm Email').Field)
        };
    };


    function register() {
        var success = true;
        var $errorContainer = $('#registerContainer .errorContainer');
        var errorMsg = '';
        $errorContainer.html('');

        var isValid = Roc.Validation.validateForm(forms.CustomRegistration);

        if (registrationData.$email.val() !== registrationData.$email2.val()) {
            isValid = false;
            errorMsg = 'Given email addresses aren\'t the same';
        }

        if (isValid) {
            success = true;
            Roc.Core.lockButton(btns.register);
            var requestData = Roc.Validation.getFieldValues(forms.CustomRegistration);
            $.proxyRequest({
                url: '/api/members/add/new/',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(requestData),
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.isSuccess) {
                        window.location.replace(redirectUrl);
                    }
                    if (response.errorMessage) {
                        $errorContainer.html(response.errorMessage);
                    }
                    Roc.Core.releaseLockedButton(btns.register);
                }
            });

        } else {
            $errorContainer.html(errorMsg);
            success = false;
        }
        return success;
    }


    function init(options) {
        bindEvents();
        redirectUrl = options.RedirectPage;
        initRegistration();
    };

    var Registration = {
        init: init
    }

    Roc.Logger.debug('Registration.js Loaded:', Registration);

    return Registration;
});
